import { Box, Typography } from "@mui/material";

function Error() {
  return (
    <Box sx={{ display: "flex" }}>
      <Typography variant="h6" sx={{ textAlign: "center" }} color="error">
        An Error Occurred
      </Typography>
    </Box>
  );
}

export default Error;
